import {
  LinearProgress,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setOpen } from "../../Redux/ModalReducer";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import DataTable from "./data-table";
import DeleteModal from "./DeleteModal";

export const SmmticketCampaingsTable = ({campaings,getData,currentPage,setCurrentPage,rowsPerPage,setRowsPerPage}) => {
  const [data, setData] = useState(campaings);
  const [isLoading, setIsLoading] = useState(true);

  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const dispatch = useDispatch();
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleShow = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };
  const getOldData = async () => {
    setData(campaings)
    setIsLoading(false);
    //
    // const { response, message } = await Helper.Get({
    //   url: `${api_Routes.UserAds.View}?per_page=${rowsPerPage}&page=${
    //     currentPage + 1
    //   }`,
    //   hasToken: true,
    // });
    // if (response) {
    //   setData(response);
    // }
    // setIsLoading(false);
  };

  useEffect(() => {
    if (shouldRefresh) {
      setCurrentPage(0);
      setShouldRefresh(false);
      getData();
    }
  }, [shouldRefresh]);

  useEffect(() => {
    getData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    getOldData();
  }, [campaings]);

  return (
    <div>
      {/* Filter Section */}

      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable
                data={data?.data}
                getData={getData}
                setSelectedId={setSelectedId}
                handleShow={handleShow}/>
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data.pagination.total}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[1,5,10,20, 25, 50]}
            />
          </div>
          <DeleteModal
              show={show}
              handleClose={handleClose}
              selectedId={selectedId}
              setShouldRefresh={setShouldRefresh}
          />
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
